import styled from 'styled-components';

export const ActionsCellStyled = styled.div`
  align-items: center;
  display: flex;

  gap: 6px;

  button {
    padding: 6px 6px;
  }
`;
